<app-navbar></app-navbar>
<section class="pt-5">
  <div class="container">
    <div class="row">
      <ng-container *ngFor="let item of GBMessages">
        <div class="col-md-6 mb-4">
          <div class="card slide-wrapper h-100">
            <div class="card-body d-flex flex-column">
              <h2 class="card-title text-center">{{ item.GBDesignationName }}'s Message</h2>
              <hr>
              <img class="photo card-img-top img-fluid" [src]="item.GBImagePath" alt="Message Image"
                style="max-height: 200px; object-fit: contain;" />
              <h4 class="card-subtitle mt-4">{{ item.GBName }}</h4>
              <hr />
              <p class="card-text">{{ truncateText(item.DetailsEn, 200) }}</p>
              <div class="mt-auto text-right">
                <a [routerLink]="getMessageHref(item.GBDesignationName)" class="btn btn-primary read-more">Read More</a>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</section>
